import * as React from 'react';
import * as Loadable from 'react-loadable';

const OperatorBettingRulesENLazy: React.ComponentType<{}> = Loadable({
    loader: () => import(/* webpackChunkName: "betting-rules-EN" */'./betting-rules-EN'),
    loading: () => null,
});

export default OperatorBettingRulesENLazy;